import React from 'react';
import { useForm } from '@formcarry/react';
import {
  Form, Container, Col, Button,
} from 'react-bootstrap';

function OrgSignupSection() {
  // Call the `useForm` hook in your function component
  const { state, submit } = useForm({
    id: 'MaMqc1xLzy1R',
  });
  // Success message
  if (state.submitted) {
    return (
      <div className="site-section" id="contact-form">
        <Container style={{ backgroundColor: 'white' }}>

          {/* <br/><br/> */}
          <h2>Thank you! </h2>
          We received your submission and will be in touch shortly!
          <br />
          <br />
          <a href="/" className="hero-button">Back to Home</a>
        </Container>
      </div>
    );
  }
  return (
    <div className="site-section" id="contact-form">
      <Container style={{ backgroundColor: 'white' }}>
        <Form
          onSubmit={submit}
        >
          <Form.Group>
            <h1>Get in touch</h1>
            <p>
              Please complete this form and a Big & Mini
              representative will contact you shortly.
            </p>

            <Form.Row>
              <Form.Group as={Col} controlId="formBasicName">
                <Form.Label> Name</Form.Label>
                <Form.Control type="text" name="First Name" required placeholder="Enter Full Name" />

              </Form.Group>
              {/* <Form.Group as={Col}  controlId="formBasicName">
     <Form.Label>Last Name</Form.Label>
     <Form.Control type="text" name = "Last Name" required placeholder="Enter Last Name" />

   </Form.Group> */}

              <Form.Group as={Col} controlId="formBasicEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" name="Email" required placeholder="Enter Work Email" />
              </Form.Group>

            </Form.Row>

            <Form.Group controlId="formBasicName">
              <Form.Label>Organization</Form.Label>
              <Form.Control type="text" name="Organization" required placeholder="Enter Organization Name" />

            </Form.Group>
            <Form.Group controlId="formBasicName">
              <Form.Label>Title</Form.Label>
              <Form.Control type="text" name="title" required placeholder="Enter Job Title" />

            </Form.Group>
            <Form.Group controlId="exampleForm.ControlTextarea1">
              <Form.Label>Comments (optional)</Form.Label>
              <Form.Control as="textarea" name="Comments" rows="2" />
            </Form.Group>

            <Button variant="primary" type="submit">
              Submit
            </Button>

          </Form.Group>
        </Form>
      </Container>
    </div>
  );
}

export default OrgSignupSection;
